import { 
  ADD_ACCOUNT,
  GET_PROFILE ,
  GET_LIST_ACCOUNT,
  PUT_LIST_ACCOUNT,
  DELETE_ACCOUNT,
  GET_PROFILE_CTV,
  PUT_ACCOUNT_CTV
} from "../type"

const initialState = {
  profileUser: null,
  listAccount: [],
  countAccount: 0,
  listAccountCtv: [],
  countAccountCtv: 0
}

const profile = (state = initialState, action) => {
  switch(action.type) {
    case ADD_ACCOUNT:
      return {
        ...state,
        listAccount: [...state.listAccount, action.data]
      }
    case GET_PROFILE: 
      return {
        ...state,
        profileUser: action.data
      }
    case GET_LIST_ACCOUNT: 
      return {
        ...state,
        listAccount: action.data.data,
        countAccount: action.data.count
      }
    case PUT_LIST_ACCOUNT:
      return {
        ...state,
        listAccount: state.listAccount.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_ACCOUNT: 
      return {
        ...state,
        listAccount: state.listAccount.filter(
          (item) => item._id !== action.data.data.id 
        )
      }
    case GET_PROFILE_CTV:
      return {
        ...state,
        listAccountCtv: action.data.data,
        countAccountCtv: action.data.count
      }
    case PUT_ACCOUNT_CTV:
      return {
        ...state,
        listAccountCtv: state.listAccountCtv.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
      default: {
        return state
      }
  }
}
export default profile